export default function PricingSection() {
  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-[#FAF0E6] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            <div className="relative h-[500px] lg:h-[600px]">
              <img 
                alt="企業向けデジタル制作サービス案内 - チラシ制作・ネットショップ立ち上げ・タスク効率化アプリ制作の料金表とサービス詳細" 
                className="w-full h-full object-cover object-top" 
                src="https://static.readdy.ai/image/a94bf782443eac1605091ed034a69659/37c9806e7cd78bb9590f4e4d800ae5b5.jpeg"
              />
            </div>

            <div className="p-8 sm:p-12 lg:p-16 space-y-8">
              <div className="text-center space-y-4">
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2C2C2C]">
                  よりみち相談 digital Support
                </h2>
                <p className="text-lg sm:text-xl text-[#757575] leading-relaxed">
                  お客様のニーズを汲み取り、ビジネスの成長に貢献いたします。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-gradient-to-br from-[#E8F5E9] to-[#C8E6C9] rounded-2xl p-6 space-y-3">
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full">
                    <i className="ri-file-paper-2-line text-2xl text-[#66BB6A]"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#2C2C2C]">チラシ作成</h3>
                  <p className="text-base text-[#2C2C2C] leading-relaxed">
                    ヒアリングを元に、チラシやデザイン作成します。ご希望で印刷業者への入稿も承ります
                  </p>
                  <div className="text-2xl font-bold text-[#66BB6A]">¥4,500</div>
                  <div className="text-sm text-[#757575]">(デザイン片面)</div>
                </div>

                <div className="bg-gradient-to-br from-[#E8F5E9] to-[#C8E6C9] rounded-2xl p-6 space-y-3">
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full">
                    <i className="ri-shopping-cart-line text-2xl text-[#66BB6A]"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#2C2C2C]">ネットショップ作成</h3>
                  <p className="text-base text-[#2C2C2C] leading-relaxed">
                    BASEを用いたネットショップサイト制作。商品登録や各種設定もご希望で承ります。
                  </p>
                  <div className="text-2xl font-bold text-[#66BB6A]">¥20,000〜</div>
                </div>

                <div className="bg-gradient-to-br from-[#E8F5E9] to-[#C8E6C9] rounded-2xl p-6 space-y-3">
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full">
                    <i className="ri-smartphone-line text-2xl text-[#66BB6A]"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#2C2C2C]">業務改善アプリ制作</h3>
                  <p className="text-base text-[#2C2C2C] leading-relaxed">
                    在庫管理アプリやオーダー受付アプリ、オリジナルタスクメモアプリなどお客様の業務に応じたミニアプリを作成します
                  </p>
                  <div className="text-2xl font-bold text-[#66BB6A]">¥38,000〜</div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-[#FAF0E6] to-[#F5F5DC] rounded-2xl p-6 sm:p-8">
                <p className="text-base sm:text-lg text-[#2C2C2C] leading-relaxed text-center">
                  <i className="ri-information-line text-xl text-[#66BB6A] mr-2"></i>
                  下記以外でもエクセルフォーム作成（半自動化）・AI導入など、お気軽にご相談ください
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
